import * as React from 'react';

// Meta corporate brand glyph (the "infinity" mark covering Facebook, Instagram,
// WhatsApp, etc.). Used for the unified Meta custom-connector tile, which
// produces both Facebook and Instagram sources from a single OAuth.
//
// Path data extracted from the official Meta_lockup_positive_primary_RGB.svg
// brand asset (the "Symbol" group's clipPath outline). Original coords are in
// the lockup space (glyph occupies x≈[1000, 2510], y≈[1000, 2000] in a 6962x3000
// canvas). We translate + scale into the icon's 40x40 user space.
export default ({ viewBox, style }) => (
  <svg width="40" height="40" viewBox={viewBox} style={style}>
    <defs>
      <linearGradient
        id="metaInfinityGrad"
        x1="1865.507"
        y1="1532.9408"
        x2="1449.0802"
        y2="987.2772"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1336" stopColor="#0869e1" />
        <stop offset="0.8727" stopColor="#0064e0" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="8" fill="#FFF" />
    <g transform="translate(3, 8) scale(0.0225)">
      <g transform="translate(-1000, -1000)">
        <path
          d="M2079.9949,1000c-123.3911,0-219.8478,92.936-307.164,210.9931C1652.8424,1058.2153,1552.4949,1000,1432.4089,1000c-244.8276,0-432.4138,318.6207-432.4138,655.8621,0,211.0344,102.0956,344.1379,273.1035,344.1379,123.0805,0,211.6-58.0259,368.9655-333.1034,0,0,65.5973-115.8413,110.7249-195.6386q23.72,38.2978,49.9647,82.5351l73.7931,124.1379C2020.294,1918.4789,2100.3854,2000,2245.5123,2000c166.5959,0,259.31-134.9233,259.31-350.3448C2504.8227,1296.5517,2313.0069,1000,2079.9949,1000Zm-557.9308,592.4138c-127.5862,200-171.7242,244.8276-242.7587,244.8276-73.1034,0-116.5517-64.1784-116.5517-178.6207,0-244.8276,122.069-495.1724,267.5862-495.1724,78.8013,0,144.6539,45.51,245.5224,189.9131C1580.0831,1500.2723,1522.0641,1592.4138,1522.0641,1592.4138Zm481.5283-25.178-88.23-147.1481q-35.8152-58.2482-68.8384-107.23c79.52-122.7353,145.1135-183.8919,223.1261-183.8919,162.0691,0,291.7243,238.6207,291.7243,531.7241,0,111.7242-36.5935,176.5518-112.4139,176.5518C2176.29,1837.2414,2141.5738,1789.2474,2003.5924,1567.2358Z"
          fill="url(#metaInfinityGrad)"
        />
      </g>
    </g>
  </svg>
);
